<script>
import ClientesService from '@/services/clientes.service';
import { PaginacionDefault, VALOR_NUMERICO_TRUE } from '@/constants/global';
import Utils from '@/functions/utils';
import spinnerService from '@/services/spinner.service';
import { STORAGE_URL } from '@/config/config';

export default {
  data() {
    return {
      loading: false,
      showPassword: false,
      showModal: false,
      asesores: [],
      paquetes: [],
      docs: [],
      tipoPlanes: [],
      contratodb: {},
      contrato: {},
      direcciones: [],
      serie: {
        factura: null,
        boleta: null,
        notaCredito: null,
        notaDebito: null,
        observaciones: null
      },
      contacto: {
        documento: null,
        nombre: null,
        telefono: null,
        correo: null,
        cargo: null
      },
      sunat: {
        usuario: null,
        clave: null
      },
      imagen: {
        url: '',
        alt: '',
        innerHtml: ''
      }
    }
  },
  async mounted() {
    const id = this.$route.params.id;
    if (id && (isNaN(id) || id <= 0)) {
      this.$router.push({
        path: '/not-found'
      });
      return;
    }
    await this.getUsuarios();
    await this.getPaquetes();
    await this.getDocumentos();
    await this.getTipoPlanes();
    await this.getContratoPorId(id);
  }
  ,
  methods: {
    async getPaquetes() {
      this.paquetes = await ClientesService.getPaquetes();
    },
    async getDocumentos() {
      this.docs = await ClientesService.getDocumentos();
    },
    async getTipoPlanes() {
      this.tipoPlanes = await ClientesService.getTipoPlanes();
    },
    async getUsuarios() {
      let res = await ClientesService.getUsuarios(PaginacionDefault.FILTRO, PaginacionDefault.PAGINA, PaginacionDefault.SIZE, PaginacionDefault.ESTADO);
      let values = res.data || [];
      this.asesores = values.map(map => {
        return { label: map.nombre, value: map.id }
      });
    },
    async getContratoPorId(id) {
      let res = await ClientesService.getContratoPorId(id);
      this.contratodb = res;
      this.contrato.id = res.id;
      this.contrato.ruc = res.ruc;
      this.contrato.razonSocial = res.razonSocial;
      this.contrato.asesorDesc = this.asesores.find(fnd => fnd.value == res.idAsesor).label;
      this.contrato.paqueteDesc = this.paquetes.find(fnd => fnd.value == res.idPaquete).label;
      this.contrato.docDesc = this.docs.find(fnd => fnd.value == res.idDocsInternos).label;
      this.contrato.numSucursales = res.numSucursales;
      this.contrato.numUsuarios = res.numUsuarios || 'ILIMITADO';
      this.contrato.numComprobantes = res.numComprobantes || 'ILIMITADO';
      this.contrato.docInternos = res.soloDocsInternos == VALOR_NUMERICO_TRUE;
      this.contrato.tipoPlanDesc = this.tipoPlanes.find(fnd => fnd.value == res.idTipoPlan)?.label ?? 'anual';
      this.contrato.costoMensual = res.costoMensual;
      this.contrato.costoPlan = res.costoPlan;
      this.contrato.costoInscripcion = res.costoInscripcion;
      this.contrato.inicioPromo = (res.fechaInicioPromo && Utils.formatFecha(res.fechaInicioPromo, 'yyyy-MM-dd')) || null;
      this.contrato.finPromo = (res.fechaFinPromo && Utils.formatFecha(res.fechaFinPromo, 'yyyy-MM-dd')) || null;
      this.contrato.inicioFacturacion = (res.fechaFacturacion && Utils.formatFecha(res.fechaFacturacion, 'yyyy-MM-dd')) || null;
      this.contrato.observaciones = res.observaciones;

      this.contrato.nombreContrato = res.nombreContrato;
      this.contrato.nombrePago = res.nombrePago;
      this.contrato.nombreLogo = res.nombreLogo;
      this.contrato.nombreCapturaPSE = res.nombreCapturaPSE;

      this.contrato.pathContrato = res.nombreContrato && res.nombreContrato != '' ? `${STORAGE_URL}/${res.nombreContrato}` : null;
      this.contrato.pathPago = res.nombrePago && res.nombrePago != '' ? `${STORAGE_URL}/${res.nombrePago}` : null;
      this.contrato.pathLogo = res.nombreLogo && res.nombreLogo != '' ? `${STORAGE_URL}/${res.nombreLogo}` : null;
      this.contrato.pathCapturaPSE = res.nombreCapturaPSE && res.nombreCapturaPSE != '' ? `${STORAGE_URL}/${res.nombreCapturaPSE}` : null;

      this.direcciones = this.contratodb.direcciones.map(map => { return { id: map.id, estado: map.estado == VALOR_NUMERICO_TRUE, descripcion: map.descripcion } });

      let contactodb = res.contactos[0];
      this.contacto.documento = (contactodb && contactodb.documento) || null;
      this.contacto.nombre = (contactodb && contactodb.razonSocial) || null;
      this.contacto.telefono = (contactodb && contactodb.telefono) || null;
      this.contacto.correo = (contactodb && contactodb.correo) || null;
      this.contacto.cargo = (contactodb && contactodb.cargo) || null;

      let sunatdb = res.sunat[0];
      this.sunat.id = (sunatdb && sunatdb.id) || 0;
      this.sunat.usuario = 'ENCRYPTED';
      this.sunat.clave = 'ENCRYPTED';

      this.serie.factura = res.serieFactura || 'No utilizada';
      this.serie.boleta = res.serieBoleta || 'No utilizada';
      this.serie.notaCredito = res.serieNotaCredito || 'No utilizada';
      this.serie.notaDebito = res.serieNotaDebito || 'No utilizada';
      this.serie.observaciones = res.observacionesCliente;
    },
    btnCancelar_click() {
      this.$router.go(-1);
    },
    verImagenPago() {
      this.imagen = {
        url: this.contrato.pathPago,
        alt: 'Pago ' + this.contrato.razonSocial,
        innerHtml: 'Pago ' + this.contrato.razonSocial
      };
      this.showModal = true
    },
    verImagenLogo() {
      this.imagen = {
        url: this.contrato.pathLogo,
        alt: 'Logo ' + this.contrato.razonSocial,
        innerHtml: 'Logo ' + this.contrato.razonSocial
      };
      this.showModal = true
    },
    verImagenPse() {
      this.imagen = {
        url: this.contrato.pathCapturaPSE,
        alt: 'PSE ' + this.contrato.razonSocial,
        innerHtml: 'PSE ' + this.contrato.razonSocial
      };
      this.showModal = true
    },
    async btnShowClave_click() {
      if(this.loading) return;
      if(!this.showPassword && (this.sunat.id == null || this.sunat.id <= 0)){
        Utils.mostrarMensajeAdvertencia('Aun No hay claves');
        this.showPassword = !this.showPassword;
        return;
      }
      this.loading = true;
      spinnerService.show();
      try {
        if (!this.showPassword) {
          let res = await ClientesService.getDatosSunat(this.sunat.id);
          this.sunat.usuario = res.usuario;
          this.sunat.clave = res.clave;
        }
        else {
          this.sunat.usuario = 'ENCRYPTED';
          this.sunat.clave = 'ENCRYPTED';
        }
        this.showPassword = !this.showPassword;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        Utils.mostrarMensajeError(error.Message || 'Ocurrio un error')
      } finally{
        spinnerService.hide();
      }

    }
  }
};

</script>
<template>
  <div class="space"></div>

  <template v-if="contrato">
    <div id="myModal" class="modal" v-if="showModal">
      <div class="modal-flex">
        <div class="inside">
          <span class="close-mod" @click="showModal = false">×</span>
          <img class="modal-content" id="imgMod" :src="imagen.url" :alt="imagen.alt">
          <div id="caption">{{ imagen.innerHtml }}</div>
        </div>
      </div>
    </div>
    <div class="container conts">
      <div class="row">
        <div class="col"></div>
        <div class="col-sm-9">
          <div class="recuadro bg-white mt-5 mb-5">
            <div class="text-center head bg-primary bg-gradient text-white p-4">
              <h1>Ver Contrato</h1>
              <p>Cliente: {{ contrato.razonSocial }}</p>
            </div>
            <div class="card-body p-5">
              <form>
                <div class="mb-3 bg-light p-3 rounded-3">
                  <div class="row">
                    <div class="col">
                      <label for="asesor" class="form-label form-control-lg">Asesor de Ventas</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="form-control form-control-lg" name="" id="" :value="contrato.asesorDesc"
                        disabled>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col">
                      <h2>Información del cliente</h2>
                    </div>
                  </div>
                </div>
                <div class="mb-3 bg-light p-3 rounded-3">
                  <div class="row">
                    <div class="col">
                      <label for="con_ruc" class="form-label form-control-lg">RUC</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="req form-control form-control-lg" name="cnt_ruc" id="cnt_ruc"
                        :value="contrato.ruc" disabled>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="con_razsoc" class="form-label form-control-lg">Razón Social</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="req form-control form-control-lg" name="cnt_razsoc" id="cnt_razsoc"
                        :value="contrato.razonSocial" disabled>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col">
                      <h2>Direcciones SUNAT</h2>
                    </div>
                  </div>
                </div>
                <div class="mb-3 bg-light p-3 rounded-3">

                  <div class="row" v-for="direccion, index in direcciones" v-bind:key="index">
                    <div class="col">
                      <label for="direc" class="form-label form-control-lg">Dirección SUNAT {{ index + 1 }}</label>
                    </div>
                    <div class="col-sm-7">
                      <div class="input-group mb-3">
                        <div v-if="direccion.estado == 1" class="input-group-text btn-primary">
                          <i class="fas fa-check-circle"></i>
                        </div>
                        <div v-else class="input-group-text btn-danger">
                          <i class="fas fa-times-circle"></i>
                        </div>
                        <input type="text" class="form-control form-control-lg" :name="'dir_des' + (index + 1)"
                          :id="'dir_cnt' + (index + 1)" :value="direccion.descripcion" disabled>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col">
                      <h2>Información del paquete contratado</h2>
                    </div>
                  </div>
                </div>
                <div class="mb-3 bg-light p-3 rounded-3">
                  <div class="row">
                    <div class="col">
                      <label for="paquete" class="form-label form-control-lg">Paquete</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="req form-control form-control-lg" name="cnt_pkt" id="cnt_pkt"
                        :value="contrato.paqueteDesc" disabled>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="con_suc" class="form-label form-control-lg">Sucursales</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="req form-control form-control-lg" name="cnt_suc" id="cnt_suc"
                        :value="contrato.numSucursales" disabled>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="con_can" class="form-label form-control-lg">Cantidad de usuarios</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="req form-control form-control-lg" name="cnt_cnt_usu" id="cnt_cnt_usu"
                        :value="contrato.numUsuarios" disabled>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="con_com" class="form-label form-control-lg">Cantidad de comprobantes</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="req form-control form-control-lg" name="cnt_cnt_com" id="cnt_cnt_com"
                        :value="contrato.numComprobantes" disabled>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="docs" class="form-label form-control-lg">Documentos internos</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="form-control form-control-lg" name="" id="" :value="contrato.docDesc"
                        disabled>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="con_com" class="form-label form-control-lg">Solo documentos internos</label>
                    </div>
                    <div class="col-sm-7">
                      <i v-if="contrato.docInternos" class="check-icon check-45 fas fa-check-circle"></i>
                      <i v-else class="check-danger check-45 fas fa-times-circle"></i>
                    </div>
                  </div>
                </div>
                <div class="mb-3 bg-light p-3 rounded-3">
                  <div class="row">
                    <div class="col">
                      <label for="con_men" class="form-label form-control-lg">Costo mensual</label>
                    </div>
                    <div class="col-sm-7">
                      <div class="input-group">
                        <span class="input-group-text">S/.</span>
                        <input type="text" class="req form-control form-control-lg" name="cnt_cos_men" id="cnt_cos_men"
                          :value="contrato.costoMensual" disabled>
                        <span class="input-group-text">.00</span>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <label for="con_plan" class="form-control-lg">Costo {{ contrato.tipoPlanDesc }} </label>
                      </div>
                    </div>
                    <div class="col-sm-7">
                      <div class="input-group">
                        <span class="input-group-text">S/.</span>
                        <input type="text" class="req form-control form-control-lg" name="cnt_cos_plan" id="cnt_cos_plan"
                          :value="contrato.costoPlan" disabled>
                        <span class="input-group-text">.00</span>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="con_ins" class="form-label form-control-lg">Costo de inscripción</label>
                    </div>
                    <div class="col-sm-7">
                      <div class="input-group">
                        <span class="input-group-text">S/.</span>
                        <input type="text" class="req form-control form-control-lg" name="cnt_cos_ins" id="cnt_cos_ins"
                          :value="contrato.costoInscripcion" disabled>
                        <span class="input-group-text">.00</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col">
                      <h2>Información adicional</h2>
                    </div>
                  </div>
                </div>
                <div class="mb-3 bg-light p-3 rounded-3">

                  <template v-if="contrato.inicioPromo != null">
                    <div class="row">
                      <div class="col">
                        <label for="con_ini" class="form-label form-control-lg">Inicio promo</label>
                      </div>
                      <div class="col-sm-7">
                        <input type="text" class="req form-control form-control-lg" name="cnt_ini" id="cnt_ini"
                          :value="contrato.inicioPromo" disabled>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <label for="con_fin" class="form-label form-control-lg">Fin promo</label>
                      </div>
                      <div class="col-sm-7">
                        <input type="text" class="req form-control form-control-lg" name="cnt_fin" id="cnt_fin"
                          :value="contrato.finPromo" disabled>
                      </div>
                    </div>
                  </template>
                  <div v-else class="row">
                    <div class="col">
                      <label for="con_ini" class="form-label form-control-lg">Promoción</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="req form-control form-control-lg" value="Sin promociones" disabled>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <label for="con_pri" class="form-label form-control-lg">Fecha inicio facturación </label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="req form-control form-control-lg" name="cnt_fec" id="cnt_fec"
                        :value="contrato.inicioFacturacion" disabled>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col">
                      <h2>Datos de Configuración</h2>
                    </div>
                  </div>
                </div>
                <div class="mb-3 bg-light p-3 rounded-3">
                  <div class="row">
                    <div class="col">
                      <label for="contac" class="form-label form-control-lg">DNI de la persona de contacto</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="form-control form-control-lg" name="con_dni" id="con_dni"
                        :value="contacto.documento" disabled>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="contac" class="form-label form-control-lg">Nombre</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="form-control form-control-lg" name="con_nom" id="con_nom"
                        :value="contacto.nombre" disabled>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="contac" class="form-label form-control-lg">Teléfono</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="form-control form-control-lg" name="con_tel" id="con_tel"
                        :value="contacto.telefono" disabled>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="contac" class="form-label form-control-lg">Correo Eletrónico</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="form-control form-control-lg" name="con_ema" id="con_ema"
                        :value="contacto.correo" disabled>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="contac" class="form-label form-control-lg">Cargo en la empresa</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="form-control form-control-lg" name="con_car" id="con_car"
                        :value="contacto.cargo" disabled>
                    </div>
                  </div>
                </div>
                <div class="mb-3 bg-light p-3 rounded-3">
                  <div class="row">
                    <div class="col">
                      <label for="contac" class="form-label form-control-lg">Usuario</label>
                    </div>
                    <div class="col-sm-7">
                      <input :type="showPassword ? 'text' : 'password'" class="form-control form-control-lg"
                        name="sun_usr" id="sun_usr" :value="sunat.usuario" disabled>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="contac" class="form-label form-control-lg">Clave Sol</label>
                    </div>
                    <div class="col-sm-7">
                      <div class="input-group mb-3">
                        <input :type="showPassword ? 'text' : 'password'" class="form-control form-control-lg"
                          name="sun_sol" id="sun_sol" :value="sunat.clave" disabled>
                        <button class="btn btn-outline-secondary btn-lg" type="button" id="show"
                          @click="btnShowClave_click"><i id="icon" class="fas"
                            v-bind:class="{ 'fa-eye-slash': !showPassword, 'fa-eye': showPassword }"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-3 bg-light p-3 rounded-3">
                  <div class="row">
                    <div class="col">
                      <label for="cnt_doc_con" class="form-label form-control-lg">Facturas</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="form-control form-control-lg" name="cnt_ser_fac" id="cnt_ser_fac"
                        :value="serie.factura" style="text-transform: uppercase" disabled>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="cnt_doc_con" class="form-label form-control-lg">Boletas</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="form-control form-control-lg" name="cnt_ser_bol" id="cnt_ser_bol"
                        :value="serie.boleta" style="text-transform: uppercase" disabled>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="cnt_doc_con" class="form-label form-control-lg">Nota de Crédito</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="form-control form-control-lg" name="cnt_ser_cre" id="cnt_ser_cre"
                        :value="serie.notaCredito" style="text-transform: uppercase" disabled>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="cnt_doc_con" class="form-label form-control-lg">Nota de Débito</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="form-control form-control-lg" name="cnt_ser_deb" id="cnt_ser_deb"
                        :value="serie.notaDebito" style="text-transform: uppercase" disabled>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="con_obs" class="form-label form-control-lg">Observaciones del cliente</label>
                    </div>
                    <div class="col-sm-7">
                      <textarea name="cnt_obs" class="form-control form-control-lg" id="cnt_obs_cli"
                        :value="serie.observaciones" rows="1" disabled></textarea>
                    </div>
                  </div>
                </div>
                <div class="mb-3 bg-light p-3 rounded-3">
                  <div class="row">
                    <div class="col">
                      <label for="con_obs" class="form-label form-control-lg">Observaciones vendedor</label>
                    </div>
                    <div class="col-sm-7">
                      <textarea name="cnt_obs" class="form-control form-control-lg" v-model="contrato.observaciones"
                        id="cnt_obs" rows="2" disabled></textarea>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col">
                      <h2>Archivos guardados</h2>
                    </div>
                  </div>
                </div>
                <div class="mb-3 bg-light p-3 rounded-3">
                  <div class="row">
                    <div class="col">
                      <label for="cnt_doc_con" class="form-label form-control-lg">Contrato</label>
                    </div>
                    <div class="col-sm-7">
                      <a v-if="contrato.pathContrato == null || contrato.pathContrato == ''"
                        class="btn btn-secondary form-control btn-lg">Descargar Contrato</a>
                      <a v-else :href="contrato.pathContrato" target="_blank"
                        class="btn btn-success form-control btn-lg" title="Descargar Contrato"><i
                          class="fas fa-download"></i></a>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="cnt_doc_con" class="form-label form-control-lg">Pago</label>
                    </div>
                    <div class="col-sm-7">
                      <a v-if="contrato.pathPago == null || contrato.pathPago == ''"
                        class="btn btn-secondary form-control btn-lg">Sin Pago</a>
                      <template v-else>
                        <div class="input-group">
                          <a class="btn btn-primary form-control btn-lg" @click="verImagenPago" title="Ver Pago"><i
                              class="fas fa-eye"></i></a>
                          <a :href="contrato.pathPago" target="_blank" class="btn btn-success form-control btn-lg"
                            title="Descargar Pago"><i class="fas fa-download"></i></a>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="cnt_log" class="form-label form-control-lg">Logo</label>
                    </div>
                    <div class="col-sm-7">
                      <a v-if="contrato.pathLogo == null || contrato.pathLogo == ''"
                        class="btn btn-secondary form-control btn-lg">Sin Logo</a>
                      <template v-else>
                        <div class="input-group">
                          <a class="btn btn-primary form-control btn-lg" @click="verImagenLogo" title="Ver Logo"><i
                              class="fas fa-eye"></i></a>
                          <a :href="contrato.pathLogo" target="_blank" class="btn btn-success form-control btn-lg"
                            title="Descargar Logo"><i class="fas fa-download"></i></a>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label for="cnt_log" class="form-label form-control-lg">Registro PSE</label>
                    </div>
                    <div class="col-sm-7">
                      <a v-if="contrato.pathCapturaPSE == null || contrato.pathCapturaPSE == ''"
                        class="btn btn-secondary form-control btn-lg">Sin PSE</a>
                      <template v-else>
                        <div class="input-group">
                          <a class="btn btn-primary form-control btn-lg" @click="verImagenPse" title="Ver PSE"><i
                              class="fas fa-eye"></i></a>
                          <a :href="contrato.pathCapturaPSE" target="_blank" class="btn btn-success form-control btn-lg"
                            title="Descargar PSE"><i class="fas fa-download"></i></a>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col"><a @click="btnCancelar_click" class="btn btn-danger form-control btn-lg">Atras</a>
                    </div>
                    <div class="col"></div>
                    <div class="col"></div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col"></div>
      </div>
    </div>
  </template>
</template>